import { useCallback } from 'react';
import type { onFocusSuggestionFunctionT, ReviewSuggestionsDetailT } from '../types';
import { SUGGESTION_CATEGORY } from '../types';
const useReviewSuggestionsHandlers = ({
  data,
  onFocusSuggestion
}: {
  data: ReviewSuggestionsDetailT[];
  onFocusSuggestion?: onFocusSuggestionFunctionT;
}) => {
  const handleFocusSuggestion = useCallback((id: string, suggestion?: ReviewSuggestionsDetailT) => {
    if (!suggestion) {
      suggestion = data.find(suggestion => suggestion.id === id);
    }
    switch (suggestion?.category) {
      case SUGGESTION_CATEGORY.SPELLING_AND_GRAMMAR:
      case SUGGESTION_CATEGORY.SOP_RECOMMENDATIONS:
        {
          onFocusSuggestion?.(suggestion?.trackId || '', {
            questionnaireId: suggestion?.questionnaireId,
            trackId: suggestion?.trackId,
            questionId: suggestion?.questionId
          }, suggestion?.category);
          break;
        }
      case SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY:
        {
          onFocusSuggestion?.(suggestion.annotationId, {
            startIndex: suggestion.startIndex
          }, suggestion.category);
          break;
        }
      default:
        break;
    }
  }, [data, onFocusSuggestion]);
  return {
    handleFocusSuggestion
  };
};
export default useReviewSuggestionsHandlers;